import { API_REQUEST_END } from 'actionTypes';
import { isEmpty } from 'lodash';

const initialState = {
  errorsByStatus: {},
  statuses: [],
};

// Handles errors that are not necessarily tied to a specific endpoint.
export default function(state = initialState, action) {
  let { type, status, errors } = action;
  switch (type) {
    case API_REQUEST_END:
      if (status === 400 || isEmpty(errors)) {
        return state;
      }
      return {
        errorsByStatus: { ...state.errorsByStatus, [status]: errors },
        statuses: [...state.statuses, status],
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/apiErrorsReducer.js